import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ERROR from 'errors/errorids';
import StickyHeader from '../../components/StickyHeader/StickyHeader';
import i18n from 'i18n/i18n';
import Logger from '../../logger/logger';
const log = Logger.get('Subscription');
import { parseQuery } from '../../utils/url';
import {
	getConnectionList,
	getAgentMlsIds,
	deleteMLSConnection,
	deleteOfficeId,
	clearConnectMlsState,
	addAgentMlsId
} from 'redux/modules/mls';
import { IconMlsIdAdd, DeleteIconRounded, SettingsIcon, SpinnerIcon } from '../../theme/icons';
import { showErrorPopup, showRateLimitError } from 'redux/modules/companies';
import {
	IconButton,
	withStyles,
	Typography,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Grid
} from '@material-ui/core';

import { Button } from '../../components/Features/components';
import { hideModal } from 'redux/modules/modal';

import Header from '../../components/Header';
import classNames from 'classnames';
import { showModal } from 'redux/modules/modal';
import { MLS_ERRORS, getTableStyleProps } from '../../utils/mls';
import CenteredContent from 'components/CenteredContent/CenteredContent';
import AppError from '../../errors/apperror';

const localize = i18n.loc.localize;

const styles = theme => ({
	/* page header */
	stickyHeader: {
		paddingBottom: 30,
		marginBottom: 60,
		'&:after': {
			width: '100%',
			margin: '0 5%',
			[theme.breakpoints.up('md')]: {
				margin: 0
			}
		}
	},
	headerDescription: {
		margin: '0 0 40px'
	},
	
	...getTableStyleProps(theme),

	/* add users button */
	buttonAddMls: {
		marginTop: 40,
		background: theme.palette.colors.black,
		paddingLeft: 20,
		paddingRight: 20
	},
	iconMlsAdd: {
		width: 15,	
		marginRight: 10,
		color: theme.palette.colors.white
	},
	buttonInviteUsers: {
		marginLeft: '8px',
		background: theme.palette.colors.white,
		border: '1px solid black',
		paddingLeft: 20,
		paddingRight: 20,
		'&:hover': {
			borderWidth: '1px'
		}
	},

	/* MLS list */

	/* no mls message */
	noMlsConnected: {
		border: '1px solid #dedede',
		borderRadius: 5,
		padding: '35px 25px'
	},
	mlsList: {
		marginBottom: 40,
		border: '1px solid #dedede',
		borderRadius: 5,
		padding: '24px 25px',
		position: 'relative'
	},
	mlsListHeader: {
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	mlsListHeaderTitle: {
		marginBottom: 25
	},
	mlsListHeaderButtons: {
		textAlign: 'right',
		marginBottom: 25
	},
	buttonManageMls: {
		marginLeft: '8px',
		background: theme.palette.colors.white,
		border: '1px solid black',
		paddingLeft: 20,
		paddingRight: 20,
		'&:hover': {
			borderWidth: '1px'
		}
	},
	iconManageMls: {
		marginRight: 5
	},
	table: {
	},
	buttonDeleteOffice: {
		padding: 0,
		'&:hover': {
			background: 'none',
		},
		'&:hover svg': {
			color: theme.palette.common.black
		}

	},
	iconDeleteOffice:  {
		color: theme.palette.colors.zeta
	},
	/* loading icon */
	loadingContainer: {
		minHeight: 400,
		width: '100%',
		position: 'relative',
	},
	loadingContainerOfficeRow: {
		minHeight: 20,
	},
	loadingContainerConnectionRow: {
		minHeight: 47,
	},
	loadingContent: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)'
	},
	loadingMessage: {
		fontSize: 16,
		lineHeight: 1.5,
		opacity: 1,
		marginTop: 10
	},
	loadingIcon: {
		display: 'block',
		height: '24px',
		width: '24px',
		margin: '0 auto',
		fill: '#96DCFD',
		animation: 'spin 2s linear infinite'
	},
	'@keyframes spin': {
		'0': {
			transform: 'rotate(0deg)'
		},
		'100%': {
			transform: 'rotate(360deg)'
		}
	},

	/* error message */
	errorMessage:  {
		color: theme.palette.error.main,
		fontSize: 14,
		lineHeight: 1.5,
		opacity: 1,
		textAlign: 'center',
		padding: 100,
		width: '100%',
		'&.inline': {
			padding: 0
		},
		'&.dense': {
			padding: '20px 20px 0'
		}
	},
});

@withStyles(styles)
class Users extends Component {

	constructor(props) {
		super(props);

		this.handleRemoveMls = this.handleRemoveMls.bind(this);
		this.onRemoveOffice = this.onRemoveOffice.bind(this);
		this.handleRemoveOffice = this.handleRemoveOffice.bind(this);
		this.handleShowAddMlsModal = this.handleShowAddMlsModal.bind(this);
		this.onModalCloseHandler = this.onModalCloseHandler.bind(this);

		this.state = {
			...this.getStateFromProps(props),
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			...this.getStateFromProps(nextProps),
		});
	}

	getStateFromProps(props) {
		const { currentPlanName } = props;
		const { rawDataById, selectedId } = props.companies;
		const company = rawDataById[selectedId];
		const { users, hasActiveSubscription } = company;

		return { users, hasActiveSubscription, currentPlanName, selectedId, company };
	}
	
	componentDidMount() {
		const queryParams = parseQuery(this.props.location.search);
		if ('show-add-mls-popup' in queryParams) {
			this.handleShowAddMlsModal();
		}

	}

	handleShowAddMlsModal() {
		this.props.showModal('ADD_MLS_CONNECTION_MODAL', { onClose: this.onModalCloseHandler});
	}

	handleAddOffice(mlsName, mlsConnectionId) {
		this.props.showModal('ADD_MLS_OFFICE_MODAL', { mlsName, mlsConnectionId, onClose: this.onModalCloseHandler });
	}	

	handleManageMlsAgents(mlsConnectionId) {
		const { connections } = this.props.mls;
		this.props.showModal('MANAGE_MLS_AGENTS_MODAL', { connections, mlsConnectionId, onClose: this.onModalCloseHandler });
	}		

	onModalCloseHandler(shouldReloadList) {
		this.props.clearConnectMlsState();
		this.props.hideModal();

		if (shouldReloadList) {
			this.props.getConnectionList();
			this.props.getAgentMlsIds();
		}
	}

	/**
	 * Called when button is pressed to delete office
	 * @param {object} params { parameter: value} list
	 * @memberof MLS
	 */	
	handleRemoveOffice(mlsConnectionId, office) {
		const { officeMlsId, officeName } = office;

		this.props.deleteOfficeId(mlsConnectionId, officeMlsId, officeName)
			.then((data) => {
				if (data instanceof AppError) {
					log.send(data);
				}
			});			
	}	

	/**
	 * Triggers when user confirms office deletion in popup
	 * @param {*} callback Method, which should be executed on confirm
	 * @param {object} params { parameter: value} list
	 * @memberof MLS
	 */
	onRemoveOffice(callbackRemoveOffice, callbackRemoveConnection, connection, office) {
		const mlsConnectionId = connection.mlsConnectionId;
		const nrOfOffices = connection.offices.length;

		if (nrOfOffices === 1) {
			this.props.showModal('CONFIRMATION_MODAL', {
				title: localize('remove-mls-confirmation-title', connection.name),
				message: {
					__html: localize('remove-mls-confirmation-description'),
				},
				buttons: [
					<Button
						key='button-cancel'
						variant='outlined'
						color='primary'
					>
						{localize('cancel')}
					</Button>,
					<Button
						key='button-confirm'
						variant='contained'
						color='primary'
						onClick={() => callbackRemoveConnection(connection)}
					>
						{localize('delete')}
					</Button>
				]
			});
		} else {
			this.props.showModal('CONFIRMATION_MODAL', {
				message: {
					__html: localize('remove-office-confirmation', office.officeName),
				},
				buttons: [
					<Button
						key='button-cancel'
						variant='outlined'
						color='primary'
					>
						{localize('cancel')}
					</Button>,
					<Button
						key='button-confirm'
						variant='contained'
						color='primary'
						onClick={() => callbackRemoveOffice(mlsConnectionId, office)}
					>
						{localize('delete')}
					</Button>
				]
			});
		}
	}
	
	/**
	 * Called when button is pressed to delete MLS
	 * @param {object} connection { parameter: value} list
	 * @memberof MLS
	 */	
	handleRemoveMls(connection) {
		const { mlsConnectionId, name } = connection;

		this.props.deleteMLSConnection(mlsConnectionId, name)
			.then((data) => {
				if (data instanceof AppError) {
					log.send(data);
				}
			});			
	}	

	getCompanyUsers() {
		const { rawDataById, selectedId } = this.props.companies;
		const company = rawDataById[selectedId];
		const { users } = company;
		return users;
	}

	render() {
		const { classes } = this.props;
		const {
			connections,
			getConnectionsSuccess,
			getConnectionsErrorId,
			getAgentsMlsIdsErrorId,
			getAgentsMlsIdsSuccess,
			mlsBoardList,
			mlsBoardListFailedToLoad
		} = this.props.mls;

		const renderNoMlsConnected = () => (
			<Grid container direction="row" className={classes.noMlsConnected}>
				<Typography variant="body2">
					{localize('mls-list-no-mls-connected')}
				</Typography>
			</Grid>
		);

		const renderOfficeRowContent = (office, officeIndex, connection, connectionIndex) => {
			const { mlsConnectionId } = connection;
			const apiError = this.props.mls.deletingMlsOfficeErrorId.find(item => item.officeMlsId === office.officeMlsId) ||
				this.props.mls.deletingMlsConnectionErrorId.find(item => item.mlsConnectionId === mlsConnectionId);

			let errorMessageKey;
			if (apiError) {
				errorMessageKey = apiError && apiError.errorId &&
									MLS_ERRORS[apiError.errorId] ||
									MLS_ERRORS[ERROR.UNKNOWN];
			}

			if (this.props.mls.deletingMlsOfficeXhrInProgress.find(item => item.officeMlsId === office.officeMlsId &&
				item.mlsConnectionId === mlsConnectionId)) {
				return (
					<TableCell
						colSpan={3}
						className={classNames(
							classes.tableLoadingCellBody,
							classes.tableCellBody
						)}
					>
						{renderLoading(null, classes.loadingContainerOfficeRow)}
					</TableCell>					
				);
			} else {
				return (
					<Fragment>
						<TableCell
							className={classNames(
								classes.tableNameCellBody,
								classes.tableCellBody
							)}
						>
							{office.officeName}
						</TableCell>						
						<TableCell 
							className={classNames(
								classes.tableIdCellBody,
								classes.tableCellBody
							)}										
						>
							{office.officeMlsId}
						</TableCell>				
						<TableCell className={classes.tableActionsCell}>
							<IconButton
								className={classes.buttonDeleteOffice}
								component='span'
								aria-label={localize('mls-list-office-delete-office')}
								onClick={() => {
									this.onRemoveOffice(
										this.handleRemoveOffice,
										this.handleRemoveMls,
										connection,
										office);		
								}}
							>
								<DeleteIconRounded className={classes.iconDeleteOffice} />
							</IconButton>

							{errorMessageKey && (
								<Fragment>
									{renderErrorMessage(errorMessageKey, true)}
								</Fragment>
							)}

						</TableCell>														
					</Fragment>
				);
			}
		};		

		const renderOffices = (offices, connection, connectionIndex) => {
			return (
				<Table className={classes.table} key={`offices-table-connection–${connectionIndex}`}>
					<TableHead>
						<TableRow className={classes.tableHeadRow}>
							<TableCell
								padding='dense'
								className={classNames(
									{
										[classes.noBorderedCell]: true,
										[classes.tableNameCellHeader]: true,
										[classes.tableCellHeader]: true,
									}
								)}>
								{localize('mls-list-office-name')}
							</TableCell>
							<TableCell
								className={classNames(
									classes.tableIdCellHeader,
									classes.noBorderedCell,
									classes.tableCellHeader,
								)}
							>
								{localize('mls-list-office-id')}
							</TableCell>		
							<TableCell>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{
							offices.map((office, officeIndex) => {
								return (
									<TableRow 
										key={`offices-table-connection–${connectionIndex}-office-${officeIndex}`}
										hover
										className={classes.tableBodyRow}
									>
										{renderOfficeRowContent(office, officeIndex, connection, connectionIndex)}
									</TableRow>								
								);
							})
						}		
					</TableBody>
				</Table>
			);
		};

		const renderMlsListHeader = ({name, mlsConnectionId}) => {
			return (
				<Grid container direction="row" className={classes.mlsListHeader}>
					<Grid item className={classes.mlsListHeaderTitle}>
						<Typography variant="h4">
							{name}
						</Typography>
					</Grid>
					<Grid item className={classes.mlsListHeaderButtons}>
						<Button
							variant='outlined'
							data-tid="button-add-office"
							color='primary'
							onClick={() => this.handleAddOffice(name, mlsConnectionId)}
							className={classes.buttonManageMls}>
							<IconMlsIdAdd className={classes.iconManageMls} />
							{localize('mls-list-add-office')}
						</Button>
						<Button
							variant='outlined'
							data-tid="button-manage-agents"
							color='primary'
							onClick={() => this.handleManageMlsAgents(mlsConnectionId)}
							className={classes.buttonManageMls}>
							<SettingsIcon className={classes.iconManageMls} />
							{localize('mls-list-manage-agents')}
						</Button>
					</Grid>
				</Grid>
			);
		};

		const renderMlsListContent = (connection, index) => {
			if (connection.offices.length) {
				return renderOffices(connection.offices, connection, index);
			} else if (this.props.mls.deletingMlsConnectionXhrInProgress.includes(connection.mlsConnectionId)) {
				return renderLoading(null, classes.loadingContainerConnectionRow);
			}
		};

		const renderMlsList = () => {
			return (
				<Fragment>
					{
						connections.map((connection, index) => {
							return (
								<Grid container direction="row" className={classes.mlsList} key={`mls-list-${index}`}>
									{renderMlsListHeader(connection)}
									{renderMlsListContent(connection, index)}
								</Grid>
							);
						})
					}
				</Fragment>
			);
		};

		const renderLoading = (messageKey, additionalClass) => {
			const { classes } = this.props;
			return (
				<div
					className={classNames(
						{
							[classes.loadingContainer]: true,
							...(additionalClass && { [additionalClass]: true })
						}
					)}				
				>
					<div className={classes.loadingContent}>
						<SpinnerIcon className={classes.loadingIcon} />
						{messageKey && (
							<Typography className={classes.loadingMessage} variant="body2">
								{localize(messageKey)}
							</Typography>
						)}
					</div>
				</div>
			);
		};

		const renderErrorMessage = (errorMessageKey, inline, dense) => {
			const errorMessage = localize(errorMessageKey);

			return (
				<Typography
					className={classNames(
						{
							[classes.errorMessage]: true,
							['inline']: inline,
							['dense']: dense,
							['errorMessage']: true
						}
					)}						
					variant="body2"
					dangerouslySetInnerHTML={{ __html: errorMessage }}
				/>
			);		
		};

		const renderMlsContent = () => {
			if (getConnectionsErrorId || getAgentsMlsIdsErrorId || mlsBoardListFailedToLoad) {
				const errorMessageKey = (getConnectionsErrorId && MLS_ERRORS[getConnectionsErrorId]) ||
				(getAgentsMlsIdsErrorId && MLS_ERRORS[getAgentsMlsIdsErrorId]) ||
				(mlsBoardListFailedToLoad && 'mls-connection-popup-error-failed-to-load-mls-board-list') ||
				MLS_ERRORS[ERROR.UNKNOWN];

				return renderErrorMessage(errorMessageKey);
			} else if (!getConnectionsSuccess || !getAgentsMlsIdsSuccess || mlsBoardList.length === 0) {
				return renderLoading('mls-list-loading');
			} else if (getConnectionsSuccess) {
				return connections.length ? renderMlsList() : renderNoMlsConnected();
			}
		};

		return (
			<CenteredContent>
				<StickyHeader className={classes.stickyHeader}>
					<Header>{localize('mls-connection-header')}</Header>
					<Button
						variant='contained'
						data-tid="button-mls-add"
						color='primary'
						onClick={() => this.handleShowAddMlsModal()}
						className={classes.buttonAddMls}>
						<IconMlsIdAdd className={classes.iconMlsAdd} />
						{localize('mls-add-button')}
					</Button>
				</StickyHeader>

				{renderMlsContent()}
			</CenteredContent>
		);
	}
}

Users.propTypes = {
	classes: PropTypes.object,
	company: PropTypes.object,
	companies: PropTypes.object,
	showModal: PropTypes.func,
	hideModal: PropTypes.func,
	location: PropTypes.object,
	settings: PropTypes.object,
	currentPlanId: PropTypes.string,
	selectedCompanyId: PropTypes.string,
	showErrorPopup: PropTypes.func.isRequired,
	mls: PropTypes.object,
	getConnectionList: PropTypes.func.isRequired,
	getAgentMlsIds: PropTypes.func.isRequired,
	deleteMLSConnection: PropTypes.func.isRequired,
	deleteOfficeId: PropTypes.func.isRequired,
	showRateLimitError: PropTypes.func.isRequired,
	clearConnectMlsState: PropTypes.func.isRequired,
	addAgentMlsId: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
	error: state.error,
	company: state.companies.rawDataById[state.companies.selectedId],
	auth: state.session.user.auth,
	companies: state.companies,
	settings: state.session.user.settings,
	selectedCompanyId: state.companies.selectedId,
	mls: state.mls
});

const mapDispatchToProps = dispatch => bindActionCreators({
	showModal,
	hideModal,
	showErrorPopup,
	getConnectionList,
	getAgentMlsIds,
	showRateLimitError,
	deleteMLSConnection,
	deleteOfficeId,
	clearConnectMlsState,
	addAgentMlsId
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Users);


// WEBPACK FOOTER //
// ./src/containers/MLSConnection/MLSConnection.js